<template>
    <div class="main-container">
        <main-header :cc="centerCoord" ></main-header>
        <map-list></map-list>
        <tool-bar></tool-bar>
        <TaskList></TaskList>
        <div id="map">
            <div class="cross" v-show="true"><i class="iconfont" style="line-height: 40px;font-size: 20px;">&#xe6b3;</i>
            </div>
            <div id="contextmenu_container" class="contextmenu">
                <ul>
                    <li @click="moveToCenter"><i class="iconfont" style="margin-right:10px">&#xea03;</i>设为中心</li>
                    <li @click="addMarker"><i class="iconfont" style="margin-right:10px">&#xe818;</i>添加地标</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Header from './Header.vue';
import ToolBar from './ToolBar.vue';
import MapList from './MapList.vue';
import TaskList from './TaskList.vue';

import formatter from '@/util/geoUtil.js'

import { map, initMap, initOverlay } from '@/util/mapManager.js'
import { plotMarker } from '../../util/plotMarker'
import { getMySource, getUserInfo } from '@/util/request.js'
import { baseLayerConfig } from '../../util/mapManager';

export default {
    name: 'Map',
    components: {
        // 注册组件
        'main-header': Header,
        'tool-bar': ToolBar,
        'map-list': MapList,
        TaskList
    },
    data() {
        return {
            centerCoord: '',
            rightBtnPointLatlng: null
        }
    },
    methods: {
        closeContextMenu() {
            let rightMenu = document.getElementById('contextmenu_container')
            if (rightMenu.style.display == 'block') {
                rightMenu.style.display = 'none'
            }
        },
        moveToCenter() {
            if (this.rightBtnPointLatlng != null) {
                map.panTo(this.rightBtnPointLatlng, {})
            }
            this.closeContextMenu()
        },
        addMarker() {
            if (this.rightBtnPointLatlng != null) {
                plotMarker(this.rightBtnPointLatlng)
            }
            this.closeContextMenu()
        }
    },
    mounted() {
        initMap('map')
        map.on("mousemove", e => {
            let latlng = e.latlng
            let latlonStr = formatter.formatLatlng(latlng)
            this.centerCoord = latlonStr
        })
        // 添加瓦片图层
        map.on('contextmenu', e => {
            let rightMenu = document.getElementById('contextmenu_container')
            let x = e.containerPoint.x
            let y = e.containerPoint.y
            this.rightBtnPointLatlng = e.latlng
            rightMenu.style.left = x + 'px';
            rightMenu.style.top = y + 'px';
            rightMenu.style.display = 'block';
        })
        map.on('click', e => {
            this.closeContextMenu()
        })
        //get map source
        getMySource().then(res => {
            if (res && res.resultCode == 1) {
                let sourceArr = res.result
                baseLayerConfig.baseLayerList = sourceArr || []
                initOverlay()
            }
        }).catch(er => {
            console.log(er)
        })
    }
}
</script>
<style scoped>
.main-container {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: gray;
}

#map {
    width: 100%;
    height: calc(100% - 65px);
}

.contextmenu {
    position: relative;
    white-space: nowrap;
    border-radius: 4px;
    padding: 10px 15px;
    background: white;
    box-shadow: 2px 3px 5px #00000040;
    font-size: 14px;
    z-index: 999;
    width: 120px;
    display: none;
}

.contextmenu li {
    text-decoration: none;
    line-height: 30px;
    height: 30px;
    cursor: pointer;
}

.contextmenu li:hover {
    background-color: #ccc;
}

.cross {
    width: 40px;
    text-align: center;
    position: absolute;
    top: calc(50% - 20px);
    left: calc(50% - 20px);
    color: red;
    z-index: 600;

}
</style>



// WEBPACK FOOTER //
// src/components/main/Map.vue